import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { takeUntil } from 'rxjs';

import { BaseComponent } from '../../../../core/components/base/base.component';
import { FeedbackService } from '../../../../core/services/feedback.service';
import { PatientTaskService } from '../../../../core/services/patient-task.service';
import { taskAssigneeSummary } from '../../../../core/utils/task-assignees';

export interface TaskInboxDialogData {
  taskId: string;
  patientName: string | null;
}

/**
 * A task assigned to the viewer, opened from their Inbox (`tasks/task-assignment.md`). Shows the task and
 * completes it; completing is what takes it out of the Inbox. Editing stays on the patient file's task page.
 */
@Component({
  selector: 'app-task-inbox-dialog',
  templateUrl: './task-inbox-dialog.component.html',
  styleUrls: ['../referral-note-review-dialog/referral-note-review-dialog.component.scss'],
})
export class TaskInboxDialogComponent extends BaseComponent implements OnInit {
  task: any = null;
  isLoading = true;
  loadError: string | null = null;
  isSaving = false;
  actionError: string | null = null;
  readonly assigneeSummary = taskAssigneeSummary;

  constructor(
    private patientTaskService: PatientTaskService,
    private dialogRef: MatDialogRef<TaskInboxDialogComponent, { changed?: boolean }>,
    @Inject(MAT_DIALOG_DATA) public data: TaskInboxDialogData,
    fs: FeedbackService,
    md: MatDialog,
  ) {
    super(fs, md);
  }

  ngOnInit(): void {
    this.patientTaskService.getTaskById(this.data.taskId).pipe(takeUntil(this.destroy$)).subscribe({
      next: (result: any) => { this.task = result?.data ?? null; this.isLoading = false; },
      error: () => { this.isLoading = false; this.loadError = 'This task could not be loaded.'; },
    });
  }

  complete(): void {
    if (!this.task || this.isSaving) return;
    this.isSaving = true;
    // Status only: the server leaves the assignees alone when the body does not mention them.
    this.patientTaskService.updateTask(this.data.taskId, { status: 'Completed' }).pipe(takeUntil(this.destroy$)).subscribe({
      next: () => { this.isSaving = false; this.dialogRef.close({ changed: true }); },
      error: () => { this.isSaving = false; this.actionError = 'The task could not be completed. Please try again.'; },
    });
  }

  close(): void {
    this.dialogRef.close({});
  }
}
